import { fetchRequestPrev } from "@providers/conect_prev";

const verSedesApi = async ( data ) => {

  try {
    const url = `previplan/integrations/obtener-sedes-por-disponibilidad`
    const response = await fetchRequestPrev(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { verSedesApi };
